export const BOTTOM_DRAWER_DELAY = 5000;
